module.exports = __webpack_public_path__ + "img/33.512f66c1.png";